module.exports = __webpack_public_path__ + "img/updownsort.398265e2.svg";